module.exports = __webpack_public_path__ + "img/2.5c1144d2.jpg";